enum EQuestContextualModalOrigin {
	verify = 'verify',
	deploy = 'deploy'
}

export { EQuestContextualModalOrigin };
